var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 17.985,
    height: 16.471,
    viewBox: "0 0 17.985 16.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-361.897 -485.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.897 485.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.408,502.284H364.371a2.471,2.471,0,0,1-2.151-3.687l6.519-11.529a2.443,2.443,0,0,1,2.15-1.255h0a2.442,2.442,0,0,1,2.15,1.255l6.518,11.529a2.471,2.471,0,0,1-2.151,3.687Zm-6.518-15.551a1.532,1.532,0,0,0-1.349.788l-6.518,11.53a1.55,1.55,0,0,0,1.349,2.313h13.036a1.55,1.55,0,0,0,1.349-2.313l-6.517-11.53A1.534,1.534,0,0,0,370.89,486.734Z",
    transform: "translate(-361.897 -485.813)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.996 490.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.393,505.121a.872.872,0,0,1-.654-.251.891.891,0,0,1-.246-.649.855.855,0,0,1,.246-.63.886.886,0,0,1,.654-.246.863.863,0,0,1,.654.246.878.878,0,0,1,.234.63.916.916,0,0,1-.234.649A.849.849,0,0,1,380.393,505.121Zm0-2.5q-.468,0-.5-.552l-.36-4.585a.944.944,0,0,1,.192-.713.829.829,0,0,1,.672-.27.8.8,0,0,1,.654.27.957.957,0,0,1,.185.713l-.36,4.585Q380.837,502.626,380.393,502.626Z",
    transform: "translate(-379.493 -496.505)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b7e4445dbb163b5b58e6d24c0fb1a6c2.svg";
export { ForwardRef as ReactComponent };